<template>
  <div class="enter-points">
    <el-dialog title="调整积分" :visible.sync="dialogShow" width="400px">
      <el-form size="small" ref="form" :model="form" :rules="rules" label-width="80px" class="dialog-form">
        <el-form-item label="修改方式" prop="pointOperationType">
          <el-select v-model="form.pointOperationType" placeholder="请选择修改方式">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="积分数值" prop="points">
          <el-input v-model="form.points" placeholder="请输入积分数值" @input="handlePointsInput"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="item" class="textarea">
          <el-input type="textarea" v-model="form.item"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="dialogShow = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handEnterPoints" :loading="dialogLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  agentAdminAddPoint
} from '@/common/api';
export default {
  name: 'EnterPoints',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        pointOperationType: '',
        points: '',
        item: ''
      },
      options: [{
        value: 'ADD',
        label: '增加'
      }, {
        value: 'SUBTRACT',
        label: '扣减'
      }],
      rules: {
        pointOperationType: [
          { required: true, message: '请选择增扣类型', trigger: 'change' }
        ],
        points: [
          { required: true, message: '请输入增扣积分数值', trigger: 'blur' }
        ]
      },
      dialogLoading: false
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    handlePointsInput(value) {
      // 只保留数字，移除非数字字符
      let filtered = value.replace(/[^\d]/g, '');
      // 移除前导零
      if (filtered.length > 1 && filtered.startsWith('0')) {
        filtered = filtered.replace(/^0+/, '');
      }
      this.form.points = filtered;
    },
    handEnterPoints() {
      this.$refs.form.validate((valid) => {
        if (!valid) return false;
        this.dialogLoading = true;
        agentAdminAddPoint({
          userId: this.$route.query.id,
          ...this.form
        }).then(res => {
          this.$message.success('修改积分成功');
          this.dialogShow = false;
          this.$emit('success');
          this.$refs.form.resetFields();
        }).catch(err => {
          this.$message.error(err.msg);
        }).finally(() => {
          this.dialogLoading = false;
        });
      });
    }
  }
}
</script>


<style scoped lang="scss">
.enter-points {
  ::v-deep .dialog-form {
    .el-input {
      width: 100%;
    }

    .el-form-item {
      margin-top: 20px;
    }
  }
}
</style>